module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0055.jpg?v=5e1be604";